<template>
    <div class="master-container-l">
        <TicketsCreatedList
            v-if="placedTicketsPopupDisplayed"
            :tickets="createdTickets"
            @close="placedTicketsPopupDisplayed = false"/>
        <bet-slip v-if="betslip != null"
            ref="betslipRef"
            :showKeyboard.prop="false"
            :canPlaceSystemBets.prop="showSystem()"
            :isMobile.prop="isMobile"
            :clientStylingUrl.prop="styleUrl"
            :showTicketList.prop="isMobile"
            :t.prop="$t"
            :betslip.prop="betslip"
            :lottoDraws.prop="betslipStore.betslipList"
            :submitOptions.prop="submitOptions"
            :submitParams.prop="submitParams"
            :forceTicketSubmitConfirmation.prop="preCheckBetConfirmation()"
            :ticketItemsOrderingPresets.prop="globals.publicConfig.website.ticketItemsOrderingPresets"
            :showHandlingFee.prop="globals.publicConfig.website.showHandlingFee"
            :showTax.prop="globals.publicConfig.website.showTax"
            :canVerifyTicket.prop="true"
            :customCss.prop="customCss"
            @submitTicket="onSubmitTicket"
            @clearticket="clearBetslip"
            @removedraw="removeLottoDraw"
            @removeitem="onRemoveItem"
            @getBetslip="openTicketModal"
            class="desktop-web-cmp"
        >
            <div slot="current-balance" class="current-balance" v-if="showBalance && !isMobile">
                <div class="balance">
                    <p>{{$t('CURRENTBALLANCE')}}:</p>
                    <span class="balance-value" ref_testcafe="virtual_terminal_balance">{{playerdata.money.balance | formatNum}}
                        <span class="light-text">{{ $getCurrencyAbbrv(playerdata.money.currency) }}</span>
                    </span>
                </div>
                <img src="../../../assets/img/icon-balance.svg" class="icon-balance">
            </div>
            <div slot="betslipShopOnline">
                <div class="bslip-shop-online" v-if="showToggleTicketType">
                    <div class="form-group">
                        <div class="switch-main">
                        <label for="switch-normal">{{$t('BETINSHOP')}}</label>
                        <input type="checkbox" class="switch" id="switch-normal" :ref_testcafe="`switchIs${betslip.betslipOnline}`" v-model="ticketOnline" :disabled="betslip.betslipLoading">
                        <label for="switch-normal" class="betonline-switch" ref_testcafe="onlineOrShopSwitch"></label>
                        <label class="right">{{$t('BETONLINE')}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="fixedStakes" >
                <div class="fixed-stakes">
                    <form name="betslip-stake-form" action="" class="bslip-fixed-stakes">
                        <a v-for="payinValue in predefinedPayinValues"
                        :key="payinValue"
                        class="button button-grey-first button-bslip-stakes"
                        @click="setPayin(String(payinValue))"
                        >
                            {{ Number(payinValue).formatCurrency() }}
                        </a>
                    </form>
                </div>
            </div>
            <div slot="ticket-list" v-if="isMobile">
                <ticket-list
                    :isMobile.prop="isMobile"
                    :clientStylingUrl.prop="styleUrl"
                    :t.prop="$t"
                    :requestAdditionalParams.prop="ticketListRequestAdditionalParams"
                    @clickTicket="openTicketModal"
                    ref="ticketListRef"/>
            </div>
        </bet-slip>
        <ticket-list
            v-if="!isMobile"
            :isMobile.prop="isMobile"
            :clientStylingUrl.prop="styleUrl"
            :t.prop="$t"
            :requestAdditionalParams.prop="ticketListRequestAdditionalParams"
            @clickTicket="openTicketModal"
            ref="ticketListRef"/>
    </div>

</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations,
} from 'vuex';
import { mapState } from 'pinia';
import moment from 'moment-timezone';
import { useCustomizationStore } from '../../store/piniaStore/customization';
import { useBetslipStore } from '../../store/piniaStore/betslip';
import TicketsCreatedList from './TicketsCreatedList.vue';

export default {
    name: 'NewBetslip',
    components: {
        TicketsCreatedList,
    },
    data()
    {
        return {
            createdTickets: [],
            betslipStore: null,
            betslip: null,
            showBetslipCalculation: true,
            styleUrl: '/web/css/assets.css, /web/css/fe-style.css',
            submitOptions: {},
            ticketOnline: false,
            placedTicketsPopupDisplayed: false,
            ticketListRequestAdditionalParams: {},
        };
    },
    async created()
    {
        this.betslipStore = useBetslipStore();
        this.betslip = this.betslipStore.getBetslip();
        this.setDefaultBetslipType();

        const ticketType = this.$route.query.freePlay === 'false' ? 'online' : 'retail';
        this.betslip.changeBetslipType(ticketType);
        let isFreePlay = false;
        if (this.$route.query.freePlay)
        {
            isFreePlay = JSON.parse(this.$route.query.freePlay);
        }

        this.setFreePlay(isFreePlay);
        if (isFreePlay || this.globals.groupId === 2)
        {
            this.ticketListRequestAdditionalParams = this.requestRealmId;
            this.betslip.changeBetslipType('retail');
            this.ticketOnline = false;
        }
        else
        {
            this.ticketListRequestAdditionalParams = this.sessionToken;
            this.betslip.changeBetslipType('online');
            this.ticketOnline = true;
        }
    },
    computed:
    {
        ...mapGetters({
            isMobile: 'isMobile',
            globals: 'globals',
            playerdata: 'playerdata',
            freePlay: 'freePlay',
            canPlaceOnlineTicket: 'canPlaceOnlineTicket',
            sessionToken: 'sessionToken',
            requestRealmId: 'requestRealmId',
        }),
        ...mapState(useCustomizationStore, ['customCss']),
        allowUnregisteredOnlineTickets()
        {
            if (this.globals.publicConfig !== undefined
            && this.globals.publicConfig.website !== undefined
            && this.globals.publicConfig.website.shopOnlineSelectorOptions !== undefined
            && this.globals.publicConfig.website.shopOnlineSelectorOptions.allowUnregisteredOnlineTickets !== undefined)
            {
                return this.globals.publicConfig.website.shopOnlineSelectorOptions.allowUnregisteredOnlineTickets;
            }

            return false;
        },
        predefinedPayinValues()
        {
            let predefinedValues = [
                1,
                2,
                5,
            ];

            if (this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.website)
            {
                if (this.globals.publicConfig.website.predefinedBetslipPayinValuesForCurrencies
                && this.playerdata
                && this.playerdata.money
                && this.playerdata.money.currency
                && this.globals.publicConfig.website
                    .predefinedBetslipPayinValuesForCurrencies[this.playerdata.money.currency])
                {
                    predefinedValues = this.globals.publicConfig.website
                        .predefinedBetslipPayinValuesForCurrencies[this.playerdata.money.currency];
                }
                else if (this.globals.publicConfig.website.predefinedBetslipPayinValues)
                {
                    predefinedValues = this.globals.publicConfig.website.predefinedBetslipPayinValues;
                }
            }

            return predefinedValues;
        },
        submitParams()
        {
            const params = {
                // itemsSortOrder: null,
                currency: this.playerdata.money.currency,
                clientRequestTimestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss.SSS'),
                userAgent: this.deviceUserAgent,
            };

            if (this.$route.query.username)
            {
                params.userId = this.$route.query.username;
                params.sessionId = this.$route.query.token;
                params.gameId = this.$route.query.gameId;
            }
            return params;
        },
        ticketType()
        {
            if (!this.betslip
            || !this.betslip.items
            || !this.betslip.items.length)
            {
                return null;
            }

            const [firstItem] = this.betslip.items;

            if (firstItem.type === 'outrights')
            {
                return 'sport';
            }

            return firstItem.type;
        },
        showToggleTicketType()
        {
            return this.globals
                && this.globals.publicConfig
                && this.globals.publicConfig.localeSetup
                && this.globals.publicConfig.localeSetup.onlineTicketOverrideEnabled
                && !this.showBalance;
        },
        shouldDisplayTicketPopup()
        {
            return this.globals.publicConfig.website !== undefined
                && this.globals.publicConfig.website.ticketListOptions !== undefined
                && this.globals.publicConfig.website.ticketListOptions.ticketSubmitSuccessPopup;
        },
        showBalance()
        {
            const me = this;

            if (me.globals.publicConfig.asCasinoGame && me.playerdata.money)
            {
                return true;
            }

            return false;
        },
    },
    methods: {
        ...mapActions({
            getBalance: 'getBalance',
            clearItemsInit: 'clearItems',
            submitTicketInit: 'submitTicket',
            toggleSportTicketUpdates: 'toggleSportTicketUpdates',
            subscribeToTicketMatch: 'subscribeToTicketMatch',
            removeTicketSubscriptionEvent: 'removeTicketSubscriptionEvent',
            removeSelectedLotteryDraws: 'removeSelectedLotteryDraws',
            clearSelectedLotteryData: 'clearSelectedLotteryData',
            setTicketData: 'setTicketData',
            clearSavedLottoNumbers: 'clearSavedLottoNumbers',
            toggleMybetsModal: 'toggleMybetsModal',
            setLastSelectedTicketOnline: 'setLastSelectedTicketOnline',
            getTicketData: 'getTicketData',
            toggleBetslipDefInit: 'toggleBetslipDef',
        }),
        ...mapMutations([
            'setFreePlay',
        ]),
        showSystem()
        {
            const me = this;
            if (me.$route.name === 'horses' || me.betslipType === 'vhorse')
            {
                return false;
            }
            return true;
        },
        setPayin(val)
        {
            /* eslint-disable-next-line */
            this.$refs.betslipRef._instance.exposed.betslipStakeRef.value.setBetAmount(val);
        },
        setDefaultBetslipType()
        {
            if (!this.canPlaceOnlineTicket)
            {
                this.betslip.changeBetslipType('retail');
                return;
            }

            if (this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.website
            && this.globals.publicConfig.website.shopOnlineSelectorOptions
            && this.globals.publicConfig.website.shopOnlineSelectorOptions.defaultOnlineSelectorValue)
            {
                this.betslip.changeBetslipType(
                    this.globals.publicConfig.website.shopOnlineSelectorOptions.defaultOnlineSelectorValue,
                );
            }

            if (this.globals.publicConfig
            && this.globals.publicConfig.website
            && this.globals.publicConfig.website.shopOnlineSelectorOptions)
            {
                if (this.canPlaceOnlineTicket
                && this.globals.publicConfig.website.shopOnlineSelectorOptions.autoSelectedTicketOnlinePlayer)
                {
                    this.betslip.changeBetslipType(
                        this.globals.publicConfig.website.shopOnlineSelectorOptions.autoSelectedTicketOnlinePlayer,
                    );
                }
                else if (
                    this.globals.publicConfig.website.shopOnlineSelectorOptions.autoSelectedTicketOnlineUnregistered
                )
                {
                    this.betslip
                        .changeBetslipType(
                            this.globals.publicConfig.website.shopOnlineSelectorOptions
                                .autoSelectedTicketOnlineUnregistered,
                        );
                }
            }
        },
        setDefaultTicketType()
        {
            if (this.betslip.betslipOnline === 'online')
            {
                this.ticketOnline = true;
            }
        },
        fetchTicketList()
        {
            /* eslint-disable-next-line */
            const ticketListRef = this.$refs.ticketListRef;
            /* eslint-disable-next-line */
            ticketListRef._instance.exposed.fetchTicketList();
        },
        setCreatedTickets(allSubmitData)
        {
            for (const ticketSubmitData of allSubmitData)
            {
                if (ticketSubmitData.error)
                {
                    continue;
                }
                this.createdTickets.push(ticketSubmitData.data);
            }
        },
        preCheckBetConfirmation(param = {})
        {
            if (this.globals.publicConfig.website !== undefined
            && this.globals.publicConfig.website.forceTicketSubmitConfirmation !== undefined
            && this.globals.publicConfig.website.forceTicketSubmitConfirmation === true
            && this.canPlaceOnlineTicket
            && (param === undefined
            || param.betConfirmed === undefined
            || param.betConfirmed === false))
            {
                if (this.globals.publicConfig.website.forceOfflineTicketSubmitConfirmation === undefined
                || this.globals.publicConfig.website.forceOfflineTicketSubmitConfirmation === true
                || (this.betslip.betslipOnline === 'online'))
                {
                    return false;
                }
            }

            return true;
        },
        async clearBetslip()
        {
            window.localStorage.setItem(
                this.betslipStore.betslipType,
                JSON.stringify([]),
            );

            if (this.betslipStore.betslipType === 'lotto')
            {
                this.betslipStore.betslipSelectedOffers = [];
                this.betslipStore.betslipSelectedNumbers = [];
            }
        },
        onRemoveItem()
        {
            const numbers = [];

            for (const item of this.betslip.items)
            {
                numbers.push(item.meta.selectedBall);
            }
            this.betslipStore.betslipSelectedNumbers = numbers;
            window.localStorage.setItem(
                'lottoNumbers',
                JSON.stringify(numbers),
            );
        },
        async openTicketModal(data)
        {
            let [ticketCode] = data.detail;

            if (ticketCode.includes(' '))
            {
                ticketCode = ticketCode.split(' ').join('');
            }

            await this.getTicketData({
                ticketCode,
            });
        },
        async submitTicketList(allSubmitData)
        {
            this.createdTickets = [];

            // Refactor this when ticket list is implemented
            const createdTickets = [];
            for (const ticketSubmitData of allSubmitData)
            {
                if (!ticketSubmitData.error)
                {
                    createdTickets.push(ticketSubmitData.data);
                }
            }

            if (createdTickets.length)
            {
                window.emit('betslipMade');

                if (createdTickets.length < 2
                && this.shouldDisplayTicketPopup)
                {
                    this.setTicketData({
                        data: createdTickets[0],
                        error: false,
                        notice: 'SUCCESS',
                    });
                }
                else
                {
                    this.createdTickets = createdTickets;
                    this.placedTicketsPopupDisplayed = true;
                }
            }
        },
        async submitTicket(betslipSubmitData)
        {
            if (this.shouldDisplayTicketPopup)
            {
                this.setTicketData(betslipSubmitData);
            }
        },
        async onSubmitTicket(payload)
        {
            const [submitData] = payload.detail;

            if (submitData.error || submitData === null)
            {
                return;
            }

            if (submitData.oneTicket)
            {
                await this.submitTicket(submitData.submitData);
            }
            else
            {
                await this.submitTicketList(submitData.submitData);
            }

            this.getBalance();
            this.fetchTicketList();
        },
        async removeLottoDraw(data)
        {
            const drawToRemove = data.detail[0];
            this.betslipStore.removeBetslip(drawToRemove);
        },
    },
    watch:
    {
        ticketOnline(val)
        {
            const ticketType = val ? 'online' : 'retail';

            this.betslip.changeBetslipType(ticketType);

            window.emit('betslipToggleOnlineOffline', {
                type: ticketType,
                query: this.$route.query,
            });
        },
        '$route.query.freePlay'(val)
        {
            const isFreePlay = JSON.parse(val);
            this.setFreePlay(isFreePlay);
            if (isFreePlay)
            {
                this.ticketListRequestAdditionalParams = this.requestRealmId;
                this.betslip.changeBetslipType('retail');
                this.ticketOnline = false;
            }
            else
            {
                this.ticketListRequestAdditionalParams = this.sessionToken;
                this.betslip.changeBetslipType('online');
                this.ticketOnline = true;
            }
        },
    },
};
</script>

<style>

</style>
